var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"pt-md-16"},[_c('v-btn',{attrs:{"to":"/","color":"primary"}},[_c('v-icon',[_vm._v("mdi-chevron-left")]),_vm._v(" Back ")],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }